module.exports = __webpack_public_path__ + "img/icons-list-1.9ff3cbcf.png";